import React from 'react';
import { Modal } from '@mui/material';
import {
  DupModalActions,
  DupModalContainer,
  DupModalDesc,
  DupModalHeadRow,
  DupModalIcon,
  DupModalItem,
  DupModalItemName,
  DupModalItemSub,
  DupModalItemTag,
  DupModalList,
  DupModalTitle,
} from './TemporaryUserStyled';
import CommonModalButton from '../../form-components/CommonModalButton';

const GENDER_LABELS = { MALE: '남성', FEMALE: '여성' };

/**
 * 같은 번호의 고객이 이미 있을 때 저장 전에 확인받는 모달.
 * 저장을 막지는 않고, 정말 같은 번호로 새로 만들 것인지만 묻는다.
 */
const PhoneDuplicateModal = ({ open, onClose, onConfirm, members = [] }) => (
  <Modal open={open} onClose={onClose} aria-labelledby="phone-duplicate-modal">
    <DupModalContainer>
      <DupModalHeadRow>
        <DupModalIcon>!</DupModalIcon>
        <div>
          <DupModalTitle>같은 번호의 고객이 이미 있습니다</DupModalTitle>
          <DupModalDesc>
            아래 고객과 동일한 번호입니다.
            <br />
            그래도 이 번호로 고객을 저장하시겠습니까?
          </DupModalDesc>
        </div>
      </DupModalHeadRow>

      <DupModalList>
        {members.map((member, index) => (
          <DupModalItem key={member.userId ?? member.memberId ?? index}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <DupModalItemName>{member.name || '-'}</DupModalItemName>
                <DupModalItemTag>{member.temporaryUserId ? '잠재회원' : '회원'}</DupModalItemTag>
                {member.gender && <DupModalItemTag>{GENDER_LABELS[member.gender] || member.gender}</DupModalItemTag>}
              </div>
              <DupModalItemSub>
                {member.phoneNumber || '-'} · {member.birthDate || '생년월일 미등록'}
              </DupModalItemSub>
            </div>
          </DupModalItem>
        ))}
      </DupModalList>

      <DupModalActions>
        <CommonModalButton variant="cancel" onClick={onClose}>
          취소
        </CommonModalButton>
        <CommonModalButton variant="submit" onClick={onConfirm}>
          같은 번호로 저장
        </CommonModalButton>
      </DupModalActions>
    </DupModalContainer>
  </Modal>
);

export default PhoneDuplicateModal;
